import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'w-full py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-yellow-200 disabled:opacity-70 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#FCD34D] text-black hover:bg-[#FBBF24] shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0',
    secondary: 'bg-white text-gray-900 border-2 border-gray-100 hover:bg-gray-50',
    ghost: 'bg-transparent text-white hover:bg-white/10'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-112">
      {isLoading ? <>
          <Loader2 className="mr-2 h-5 w-5 animate-spin" data-id="element-113" />
          Please wait...
        </> : children}
    </button>;
}